import React from "react";
import PropTypes from 'prop-types';
import cx from "classnames";

import "./Price.scss";

export const Price = ({value, prefix, suffix, ...props}) => {
  const className = cx("price", props.className);
  function renderPrice(value) {
    const isPrice = value.trim().startsWith('£');
    value = isPrice ? value.replace('£','') : value;
    const classes = cx(
      "price__value",
      {
        "price__value--pound": isPrice,
      },
      );
      return (
        <p className={classes}>{value}</p>
      )
  }
  return (
    <div className={className}>
      <div className="price__prefix">
        {prefix}
      </div>
      <div>
        {renderPrice(value)}
        <span className="price__suffix">{suffix}</span>
      </div>
    </div>
  );
};

Price.propTypes = {
  prefix: PropTypes.string,
  value: PropTypes.string.isRequired,
  suffix: PropTypes.string.isRequired,
};